<template>
  <div>
    <div class="main">
      <div class="header">
        <div :class="{ 'nav-box-pos': navPos, 'nav-box': true }">
          <!-- 导航 -->
          <div class="nav-cn">
            <div class="nav-img">
              <!-- 图标 -->
              <img
                src="../../assets/logo.png"
                alt=""
                srcset=""
                width="60"
                height="60"
              />
              <span>新纪元</span>
            </div>
            <div class="nav-item">
              <!-- 导航条 -->
              <span
                :class="activeId == 'home' ? 'active' : ''"
                @click="setActive('home')"
              >
                <a>首页</a>
              </span>
              <span
                :class="activeId == 'product' ? 'active' : ''"
                @click="setActive('product')"
                ><a>产品展示</a></span
              >
              <span
                :class="activeId == 'my' ? 'active' : ''"
                @click="setActive('my')"
                ><a>关于我们</a></span
              >
              <span
                :class="activeId == 'new' ? 'active' : ''"
                @click="setActive('new')"
                ><a>新闻动态</a></span
              >
              <span
                :class="activeId == 'call' ? 'active' : ''"
                @click="setActive('call')"
                ><a>联系我们</a></span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <h3>{{news.title}}</h3>
        <p>{{news.details}}</p>
        <div v-for="item in news.imgFileName" :key="item.time">
          <img class="img-s" :src="item|imageUrl(news)" alt="" srcset="">
        </div>
      </div>
      <el-button type="success" style="width:50%;height:50px;margin-bottom:15px;" @click="comeBack">到底啦！点我返回  ←</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      news: {},
      navPos: false,
      activeId: "home",
      time: "",
    };
  },
  filters: {
    imageUrl(val, image) {
      return require("@/assets/newsImage/" + image.time + "/" + val +'.jpg');
    },
  },
  created() {
    this.getUrlData();
  },
  mounted() {},
  methods: {
    /*
     **  @description 获取路由参数
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getUrlData() {
      this.time = this.$route.query.id;
      this.news = this.newsJSON.find(
        (key) => key.time == this.time
      );
      console.log(this.news);
    },
    /*
     **  @description 导航点击
     **  @param {}
     **  @return
     **  @author shipingan
     */
    setActive(who) {
      this.$router.push({ name: "Home", params: { activeId: who } });
    },
     /*
     *返回
     */
    comeBack(){
      this.$router.go(-1);
    }
  },
};
</script>
<style lang="less" scoped>
.main {
  width: 1200px;
  margin: 0 auto;
  font-family: monospace;
  .header {
    height: 60px;
    .nav-box {
      .nav-cn {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .nav-img {
          display: flex;
          line-height: 60px;
          color: #000;
          font-size: 30px;
          font-weight: 700;
        }
        .nav-item {
          display: flex;
          span {
            line-height: 60px;
            font-size: 20px;
            padding: 0 15px;
            cursor: pointer;
            a {
              text-decoration: none;
              color: #00000066;
            }
            a::after {
              content: "";
              display: block;
              transition: all 200ms ease-in-out 0s;
              border-top: 2px solid #fff;
              margin: -21px auto;
              width: 0;
            }
            &:hover a {
              color: #000;
            }
            &:hover a::after {
              width: 100%;
            }
          }
          .active {
            a {
              color: #000;
              &::after {
                width: 100%;
              }
            }
          }
        }
      }
    }
    // 固定导航样式
    .nav-box-pos {
      width: 100% !important;
      background-color: #fff;
      display: none;
      position: fixed;
      top: 0;
      z-index: 99999;
      box-shadow: 10px 0 10px #ccc;
      transition: all 500ms ease-in-out 0s;
      display: block;
      .nav-cn {
        .nav-img {
          color: #000;
        }
        .nav-item {
          span {
            a {
              color: #000;
            }
            &:hover a {
              color: #52d3aa;
            }
          }
          .active {
            a {
              color: #52d3aa;
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .content {
    margin: 20px 0;
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 20px;
    .img-s{
      width: 60%;
    }
  }
}
</style>
